export interface AuthenticationState {
  loggedIn: boolean;
  showTermsAndConditions: boolean;
  error: string | null;
}
